import { render, staticRenderFns } from "./FurEditor.vue?vue&type=template&id=6c489a64&scoped=true&"
import script from "./FurEditor.vue?vue&type=script&lang=js&"
export * from "./FurEditor.vue?vue&type=script&lang=js&"
import style0 from "./FurEditor.vue?vue&type=style&index=0&id=6c489a64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c489a64",
  null
  
)

export default component.exports